import {LoggingService} from "./logging.service";
import {HttpErrorResponse} from "@angular/common/http";

class Log {

  public info(message: string, ...optionalParams) {
    loggingService.doLog("info", message, optionalParams);
  }

  public debug(message: string, ...optionalParams) {
    loggingService.doLog("debug", message, optionalParams);
  }

  public warn(message: string, ...optionalParams) {
    loggingService.doLog("warn", message, optionalParams);
  }

  public log(message: string, ...optionalParams) {
    loggingService.doLog("log", message, optionalParams);
  }

  public trace(message: string, ...optionalParams) {
    loggingService.doLog("trace", message, optionalParams);
  }

  public error(message: Error, logToClient = true) {
    let status = '';
    if(!!(message as any).status){
      status = "\n" + "Status: "+ (message as any).status;
    }
    let include_current_url = true;
    if (message instanceof HttpErrorResponse) {
      include_current_url = false;
    }
    loggingService?.doLog("error", message.name + ' ' + message.message + ' ' + status, [message.stack], logToClient, include_current_url);
  }

}

export const log = new Log();
let loggingService: LoggingService;

export function setLoggerService(ls: LoggingService) {
  loggingService = ls;
}
